import { memo } from 'react';
import { clsx } from 'clsx';
import { MultiSelect } from '../Select';
import type { MultiSelectProps } from '../Select/types';
import styles from './FilterDropdowns.module.scss';

const FilterMultiDropdown = (
    props: Omit<MultiSelectProps, 'rounded'> & {
        /**
         * Use the same width for popup as trigger
         */
        matchWidth?: boolean;
    }
) => {
    return (
        <MultiSelect
            {...props}
            theme={clsx(styles.theme, {
                [styles.matchWidthTheme]: props.matchWidth,
            })}
            rounded
        />
    );
};

export default memo(FilterMultiDropdown);
